var React = require('react');

function Check (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".ac337af4-e710-4abe-90ec-bd9ec6ecc01e{fill:#fbb03b;}.a611bd7e-a1b5-4b30-9814-73b76a36d741{fill:none;stroke:#fbb03b;stroke-miterlimit:10;stroke-width:2px;}")),React.createElement("polygon",{"className":"ac337af4-e710-4abe-90ec-bd9ec6ecc01e","points":"16.19 31.79 18.92 29.05 26.38 36.51 42.8 20.08 45.54 22.82 26.38 41.98 16.19 31.79","key":1}),React.createElement("circle",{"className":"a611bd7e-a1b5-4b30-9814-73b76a36d741","cx":"30.5","cy":"30.5","r":"29.5","key":2})]);
}

Check.defaultProps = {"id":"bcfb3ece-361d-4e56-b5c0-2550948e5f65","data-name":"Lager 1","viewBox":"0 0 61 61"};

module.exports = Check;

Check.default = Check;
